import React, { useEffect, useState } from "react";
import "./RightSidebar.css";
import { fetchCandidateSubscription } from "../../api/candidateApi";

function RightSidebar({ candidateId }) {
  const [sub, setSub] = useState(null);

  useEffect(() => {
    if (!candidateId) return;

    fetchCandidateSubscription(candidateId)
      .then(res => setSub(res.data))
      .catch(() => setSub(null));
  }, [candidateId]);

  // Determine status color
  const getStatusClass = () => {
    if (!sub) return "status-red";

    if (sub.daysLeft <= 0) return "status-red"; // EXPIRED

    if (sub.daysLeft <= 4) return "status-orange"; // EXPIRING

    return "status-green"; // ACTIVE
  };

  return (
    <div className="right-panel">
      <h3>Candidate Info</h3>

      <p>Phone: ---</p>
      <p>Visa: ---</p>
      <p>Resume: ---</p>

      <hr />

      <h3>Subscription</h3>

      {!sub ? (
        <p>No Subscription Found</p>
      ) : (
        <div className="subscription-box">

          <div className={`sub-status-badge ${getStatusClass()}`}>
            {sub.daysLeft <= 0
              ? "INACTIVE"
              : sub.daysLeft <= 4
              ? "ENDING SOON"
              : "ACTIVE"}
          </div>

          <p>
            <strong>Job Title/Role:</strong> {sub.role}
          </p>
          <p>
            <strong>Daily Limit:</strong> {sub.applicationsPerDay} applications/day
          </p>
          <p>
            <strong>End Date:</strong> {sub.endDate?.substring(0, 10)}
          </p>
          <p>
            <strong>Days Left:</strong> {sub.daysLeft}
          </p>
        </div>
      )}
    </div>
  );
}

export default RightSidebar;
